import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIEffect } from './portfolio-types.effects';
import { STORE_TYPE } from './portfolio-types.model';
import { uiReducer } from './portfolio-types.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(STORE_TYPE, uiReducer), EffectsModule.forFeature([UIEffect])],
  exports: [],
})
export class UIPortfolioTypesStoreModule {}